import { render } from "./GoodsStand.vue?vue&type=template&id=2378ff2b&scoped=true"
import script from "./GoodsStand.vue?vue&type=script&lang=js"
export * from "./GoodsStand.vue?vue&type=script&lang=js"

import "./GoodsStand.vue?vue&type=style&index=0&id=2378ff2b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2378ff2b"]])

export default __exports__